var React = require('react');

function NavIconsInvoices (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m9.72 22.56-2.06-2.18-2.66 1.62v-19.54l2.87 1.25 2-2.27 2.34 2.19 2.1-2 2.09 2.37 2.6-1.31v19l-2.64-1.65-1.76 2.38-1.86-2.06zm-1.89-3.56 2 2.14 3-2.17 1.62 1.8 1.58-2.12 1.83 1.15v-15.37l-1.75.87-1.84-2.11-2 1.91-2.27-2.1-1.84 2-2-.91v16z","key":0}),React.createElement("path",{"d":"m11.59 15.1h-.4c-.88 0-1.39-.39-1.39-1.33v-.16l.92-.24v.23c0 .46.14.65.69.65h1.18c.55 0 .69-.19.69-.65v-.6c0-.45-.14-.64-.69-.64h-1.35c-1 0-1.44-.43-1.44-1.35v-.77a1.25 1.25 0 0 1 1.39-1.35h.4v-.71h.82v.71h.4a1.21 1.21 0 0 1 1.39 1.33v.14l-.92.25v-.23c0-.45-.14-.64-.69-.64h-1.18c-.55 0-.69.19-.69.64v.51c0 .45.14.64.69.64h1.35c1 0 1.44.41 1.44 1.35v.88a1.24 1.24 0 0 1 -1.39 1.34h-.4v.72h-.82z","key":1})]);
}

NavIconsInvoices.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsInvoices;

NavIconsInvoices.default = NavIconsInvoices;
